module.exports = __webpack_public_path__ + "img/img10.24efaf77.png";